import React from 'react';

const STATUS_CONFIG = {
  ACTIVE: { label: 'Activo', bg: 'bg-cyan-100', text: 'text-cyan-800', dot: 'bg-cyan-500' },
  SUSPENDED: { label: 'Suspendido', bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' },
  PENDING: { label: 'Pendiente', bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500' },
  INACTIVE: { label: 'Inactivo', bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' },
  REJECTED: { label: 'Rechazado', bg: 'bg-red-100', text: 'text-red-700', dot: 'bg-red-500' },
};

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.INACTIVE;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold font-caption ${config?.bg} ${config?.text}`}
      style={status === 'ACTIVE' ? { backgroundColor: '#B2EBF2', color: '#008B9A' } : {}}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config?.dot}`} />
      {config?.label}
    </span>
  );
};

export default StatusBadge;